    // export const baseURLImage = 'http://localhost:8000/uploads/images/';
    export const baseURLImage = 'https://cfa-server-production.up.railway.app/uploads/images/';

    export const urlFlag = `https://cfa-server-production.up.railway.app/uploads/flags/`;

    